<template>
  <nav id="sidebar" :class="{ 'mobile-responsive': isMobile }">
    <ul class="content" :style="{ backgroundColor }">
      <li
        v-for="(value, key) in options"
        :key="key"
        :class="[
          (currentPage == value.navigationPath && currentPage != '/') ||
          (currentPage == '/' && value.navigationPath == '/dashboard')
            ? 'active'
            : '',
        ]"
        @click="onCloseSidebar(value)"
      >
        <router-link :to="value.navigationPath">
          <span><i :class="value.iconClasses" /></span>
          <label>{{ value.title }}</label>
        </router-link>
      </li>
    </ul>
  </nav>
</template>
<script>
import { name as appModuleName } from '@/store/modules/app';
import { mapGetters, mapMutations } from 'vuex';
import { DASHBOARD_URL, SECURITY_URL } from '@/config';
import navMenu from '@/utils/constants/navMenu.js';

export default {
  props: {
    userSiteMap: {
      type: Array,
      default: () => [],
    },
    menuItemId: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      options: this.userSiteMap,
      selected: this.menuItemId,
    };
  },
  computed: {
    ...mapGetters(appModuleName, {
      isMobile: 'getIsMobileDensity',
    }),
    currentPage() {
      return this.$route.path;
    },
    backgroundColor() {
      if (this.isTrainingEnv()) return '#FF5B5C';
      return '#3f5b60';
    },
  },
  methods: {
    ...mapMutations(appModuleName, ['toggleNav']),
    onCloseSidebar({ id }) {
      if (navMenu.Reports === id) {
        window.open(DASHBOARD_URL, '_blank');
      } else if (navMenu.User === id) {
        window.open(SECURITY_URL, '_blank');
      } else {
        if (this.isMobile) {
          this.toggleNav();
        }
      }
    },
  },
};
</script>

<style scoped lang="scss">
#sidebar {
  min-width: 118px;
  max-width: 118px;
  height: 100%;
  top: 85px;
  left: 0;
  overflow: hidden;
  position: fixed;
  padding-bottom: 20px;
  z-index: 100;
}

#sidebar .header {
  background: linear-gradient(
    to bottom right,
    rgb(255, 255, 255) 75%,
    rgba(114, 114, 114, 0.247) 100%
  );
  padding-top: 9px;
  padding-left: 30px;
  padding-right: 55px;
  width: 118px;
  height: auto;
}

#sidebar ul.content {
  overflow: auto;
  list-style-type: none;
  font-weight: 500;
  font-size: 1.125rem;
  height: 100%;
  padding-left: 0;
  padding-top: 10px;
  text-align: center;
}

#sidebar ul.content li {
  min-height: 92px;
  padding-top: 20%;
  line-height: 16pt;
  cursor: pointer;
}

#sidebar ul.content li:last-child {
  margin-bottom: 100px;
}

#sidebar ul.content li:hover a,
#sidebar ul.content li:hover span {
  color: #b5c3bc;
}

#sidebar ul.content li.active {
  background-color: #ecf2ef;
  border-right: 2px solid #2db782;
  padding-top: 15%;
}

#sidebar ul.content li.active a {
  color: #28a474;
}

#sidebar ul.content li.active span {
  border: 1px solid #28a474;
  color: #28a474;
  display: block;
  height: 42px;
  width: 42px;
  border-radius: 30px;
  padding-top: 8px;
  padding-left: 1px;
  margin-left: 31%;
}

#sidebar ul.content a {
  color: #ffffff;
  text-decoration: none;
  width: 100%;
  height: 100%;

  font-size: 13pt;
  font-weight: 600;
}

#sidebar ul.content a i {
  font-size: 18pt;
  display: block;
  margin-bottom: 5px;
}

/*************** START MINIMIZED STYLE ***************/

#sidebar.minimized {
  min-width: 92px;
  max-width: 92px;
  margin-left: -25px;
}

#sidebar.minimized .header {
  width: 92px;
  height: 114px;
}

#sidebar.minimized ul.content {
  width: 92px;
  height: 100%;
}

#sidebar.minimized ul.content li {
  min-height: 60px;
  padding-left: 24%;
}

#sidebar.minimized ul.content li:hover,
#sidebar.minimized ul.content li.active {
  padding-top: 10%;
  padding-left: 12%;
}

#sidebar.minimized ul.content li label {
  display: none;
}

/*************** END MINIMIZED STYLE ***************/

/* scrollbar style */

/* width */
::-webkit-scrollbar {
  width: 4px;
}

/* Track */
::-webkit-scrollbar-track {
  box-shadow: inset 0 0 5px grey;
  border-radius: 10px;
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: #28a474;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: #28a474;
}
</style>
